import { EmptyFetchResponse } from '../connection.types';
import { Post } from '../helpers';

const RevokeGreenroomInvitation = ({
  meeting,
  email,
  channel,
}: {
  meeting: number;
  email: string;
  channel: number;
}): Promise<EmptyFetchResponse> => {
  return Post({
    host: import.meta.env.VITE_GREENROOM_API,
    path: '/v2/greenroom/revoke-invitation',
    includeBlToken: true,
    body: {
      channel,
      meeting,
      email,
    },
    headers: {
      'bl-global-resource': 'false',
    },
  });
};

export default RevokeGreenroomInvitation;
